import React, { type MouseEvent } from 'react';
import Button from '@atlaskit/button';
import InlineMessage from '@atlaskit/inline-message';
import type { AnalyticsEvent } from '@atlassian/jira-common-analytics-v2-wrapped-components/src/types';
import type { IntlShapeV2 as Intl } from '@atlassian/jira-intl';
import { isCustomMessageForLinkingWithoutPermissionsEnabled } from '../../../feature-flags';
import messages from './messages';
import {
	InlineMessageButtonPadding,
	InlineMessageRightButtonPadding,
	InlineMessageButtonsWrapper,
	InlineMessageHeading,
	InlineMessageText,
} from './styled';

export const renderInlineMessage = (
	intl: Intl,
	headerMessage: string,
	contentMessage: string | string[],
	onRetryClick: (arg1: MouseEvent<HTMLElement>, arg2: AnalyticsEvent) => void,
	onCancelClick: () => void,
	userHasPermissionToLink?: Boolean,
) => {
	const RetryButtonOld = (
		<Button
			onClick={onRetryClick}
			interactionName="auto-generated.jira-issue-view-common-views.issue-line-card.view.inline-message.button"
		>
			{intl.formatMessage(messages.retry)}
		</Button>
	);
	const RetryButtonNew = userHasPermissionToLink ? (
		<InlineMessageRightButtonPadding>
			<Button
				onClick={onRetryClick}
				interactionName="auto-generated.jira-issue-view-common-views.issue-line-card.view.inline-message.button1"
			>
				{intl.formatMessage(messages.retry)}
			</Button>
		</InlineMessageRightButtonPadding>
	) : null;
	const cancelButtonOld = (
		<InlineMessageButtonPadding>
			<Button
				appearance="subtle"
				onClick={onCancelClick}
				interactionName="auto-generated.jira-issue-view-common-views.issue-line-card.view.inline-message.button2"
			>
				{intl.formatMessage(messages.cancel)}
			</Button>
		</InlineMessageButtonPadding>
	);
	const cancelButtonNew = (
		<Button
			appearance="subtle"
			onClick={onCancelClick}
			interactionName="auto-generated.jira-issue-view-common-views.issue-line-card.view.inline-message.button3"
		>
			{intl.formatMessage(messages.cancel)}
		</Button>
	);

	return (
		<InlineMessage appearance="warning" placement="bottom-end">
			<div>
				<InlineMessageHeading>{headerMessage}</InlineMessageHeading>
				{Array.isArray(contentMessage) ? (
					contentMessage.map((message, idx) => (
						<InlineMessageText key={idx}>{message}</InlineMessageText>
					))
				) : (
					<InlineMessageText>{contentMessage}</InlineMessageText>
				)}
				<InlineMessageButtonsWrapper>
					{isCustomMessageForLinkingWithoutPermissionsEnabled() ? RetryButtonNew : RetryButtonOld}
					{isCustomMessageForLinkingWithoutPermissionsEnabled() ? cancelButtonNew : cancelButtonOld}
				</InlineMessageButtonsWrapper>
			</div>
		</InlineMessage>
	);
};
